import React from "react";
import "../../../css/MonthAuth.css";
import mobility from "../../../img/ride.png";

interface MonthAuthProps {
  ThisMonth: string;
  LastMonth: string;
}

const MonthAuth = ({ ThisMonth, LastMonth }: MonthAuthProps) => {
  return (
    <div className="auth_month_container">
      <div className="auth_display">
        <img className="mobility" src={mobility} />
        <div className="auth_month_title">今月の認証完了者数</div>
      </div>
      <div className="auth_month_of">
        {ThisMonth} <span className="unit">人</span>
      </div>
      <div className="auth_last_month">
        先月の認証完了者数:
        <span className="auth_last_month_number">
          {LastMonth}
          <span className="unit">人</span>
        </span>
      </div>
    </div>
  );
};

export default MonthAuth;
